import React from "react";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <div
      className="breadcumb-wrapper"
      style={{
        backgroundImage: "url('/assets/image/clean7.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "350px", // or any desired height
        display: "flex",
        alignItems: "flex-end", // this pushes content to the bottom
        paddingBottom: "30px", // space from bottom edge
      }}
    >
      <div className="container mt-5">
        <div className="breadcumb-content">
          <h1 className="breadcumb-title">Our Projects</h1>
          <ul className="breadcumb-menu">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>Project</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
